export default () => ({
    schedules: [],
    selectedSchedules: [],
    loadingAppointments: false,
    events: [],
    surgicalEvents: [],
})